<template>
  <div class="comment-item" :class="{ you: currentUser.id === comment.author_id }" v-loading="deleting">
    <div class="body">
      <el-tag class="label" type="warning" size="mini" v-if="comment.label && currentUser.id !== comment.author_id">
        {{ $t(`modules.comment.tags.${comment.label}`) }}
      </el-tag>
      {{ comment.text }}
      <el-button size="text" circle @click="handleDeleteComment" v-if="currentUser.id === comment.author_id">
        <el-tooltip effect="dark" content="Remove your comment" placement="bottom">
          <i class="fa fa-trash-alt"/>
        </el-tooltip>
      </el-button>
    </div>
    <p>      
      <span class="author">
        <span v-if="currentUser.id === comment.author_id">
          You
        </span>
        <span v-else>
          {{ comment.author.email }}
        </span>
      </span>
      | {{ comment.created_at | formatTime }}
    </p>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  export default {
    name: 'CommentItem',
    props: {
      comment: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapGetters('entities/users', ['currentUser']),
      ...mapGetters('entities/comments', ['isDeleting']),

      deleting() {
        return this.isDeleting(this.comment.id);
      },
    },
    methods: {
      ...mapActions('entities/comments', ['deleteComment']),

      handleDeleteComment() {
        this.$confirm('Do you really want to delete this comment?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          title: 'Confirm',
        }).then(() => {
          this.deleteComment(this.comment.id)
            .then((response) => {
              if (response.status) {
                showSuccessMessage('Comment has been deleted successfully');
              } else {
                showErrorMessage(response.error);
              }
            });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .comment-item {
    margin-bottom: 15px;
    .body {
      padding: 20px;
      border-radius: 5px;
      background: #f6f6f6;
      position: relative;
      width: 75%;

      .el-button {
        position: absolute;
        top: 5px;
        right: 5px;
        color: #fff;
        &:hover{
          color: #606266;
        }
      }
    }
    p {
      margin-top: 4px;
      font-size: 12px;
      text-align: left;
      color: #aaa;
      .author {
        font:{
          style: italic;
          weight: bold;
        }
        color: #999;
      }
    }

    &.you {
      text-align: right;
      .body {
        background: #79bbff;
        text-align: left;
        display: inline-block;
        color: #fff;
      }
      p{
        text-align: right;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/comment/CommentItem.vue